<template>
	<div class="loading-content d-flex align-items-center justify-content-center" style="height: 200px;">
		<div class="d-flex align-items-center justify-content-center">
			<ProgressSpinner class="ps-2 align-items-center" style="width: 50px; height: 50px;"></ProgressSpinner>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	
	export default defineComponent({
	});
</script>